import React from 'react';
import { Lock, Shield, Mail, LockKeyhole } from 'lucide-react';
import { motion } from 'framer-motion';
export function PrivacySection() {
  return <section className="w-full py-24 px-4 bg-gradient-to-b from-[#0a0a0a] via-[#14100c] to-[#0a0a0a] border-y border-[#D4AF37]/10" data-id="element-244">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-245">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="w-20 h-20 rounded-full bg-[#1A1A1A] border-2 border-[#D4AF37]/40 flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(212,175,55,0.15)]" data-id="element-246">
          <Lock className="w-10 h-10 text-[#D4AF37]" data-id="element-247" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-playfair text-3xl sm:text-4xl text-white mb-4" data-id="element-248">
          Tu privacidad es sagrada para mí
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-inter text-[#D4AF37] text-lg mb-12 italic" data-id="element-249">
          Todo queda entre nosotras. Siempre.
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full text-left" data-id="element-250">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex items-start gap-4 bg-[#111] p-5 rounded-xl border border-white/5" data-id="element-251">
            <Shield className="w-6 h-6 text-[#D4AF37] shrink-0" data-id="element-252" />
            <p className="font-inter text-gray-300 text-sm" data-id="element-253">
              Tus datos personales nunca se comparten — jamás
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex items-start gap-4 bg-[#111] p-5 rounded-xl border border-white/5" data-id="element-254">
            <Mail className="w-6 h-6 text-[#D4AF37] shrink-0" data-id="element-255" />
            <p className="font-inter text-gray-300 text-sm" data-id="element-256">
              Toda comunicación llega de forma privada por correo
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="flex items-start gap-4 bg-[#111] p-5 rounded-xl border border-white/5" data-id="element-257">
            <LockKeyhole className="w-6 h-6 text-[#D4AF37] shrink-0" data-id="element-258" />
            <p className="font-inter text-gray-300 text-sm" data-id="element-259">
              Tu pago está protegido con encriptación SSL
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="flex items-start gap-4 bg-[#111] p-5 rounded-xl border border-white/5" data-id="element-260">
            <Lock className="w-6 h-6 text-[#D4AF37] shrink-0" data-id="element-261" />
            <p className="font-inter text-gray-300 text-sm" data-id="element-262">
              Lo que compartís conmigo queda conmigo
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}